<div class="flex-col">
  <form [formGroup]="userFormGroup">
    <div class="flex-row">
      <mat-form-field appearance="outline" class="order-number" [class.ro]="!usePassword">
        <mat-label>{{'users.popup.order_num' | translate }}</mat-label>
        <input matInput required formControlName="orderNum" [readonly]="!usePassword">
        <mat-error *ngIf="userFormGroup.get('orderNum')?.hasError('required')">
          {{'users.popup.err_order_num_required' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'users.popup.first_name' | translate }}</mat-label>
        <input matInput required formControlName="firstName">
        <mat-error *ngIf="userFormGroup.get('firstName')?.hasError('required')">
          {{'users.popup.err_first_name_required' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'users.popup.last_name' | translate }}</mat-label>
        <input matInput required formControlName="lastName">
        <mat-error *ngIf="userFormGroup.get('lastName')?.hasError('required')">
          {{'users.popup.err_last_name_required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex-row">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{'users.popup.email' | translate }}</mat-label>
          <input matInput required formControlName="email">
          <mat-error *ngIf="userFormGroup.get('email')?.hasError('required')">
            {{'users.popup.err_email_required' | translate}}
          </mat-error>
          <mat-error *ngIf="userFormGroup.get('email')?.hasError('alreadyExist')">
            {{ 'users.popup.already_exist_error' | translate }}
          </mat-error>
          <mat-error *ngIf="userFormGroup.get('email')?.hasError('email')">
            {{ 'users.popup.email_error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="flex-row" [class.hide]="userFormGroup.get('password')?.disabled">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>{{'users.popup.password' | translate }}</mat-label>
          <input matInput type="password" formControlName="password">
          <mat-error *ngIf="userFormGroup.get('password')?.hasError('required')">
            {{'users.popup.err_password_required' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
